// extracted by mini-css-extract-plugin
export default {"container":"UserMoneyUnit_container__s4THB","transaction_btn":"UserMoneyUnit_transaction_btn__GCsaP"};